import { FINANCE_FILE_ACCEPT } from '@/components/Financeiro/solicitacoes/financeSolicitacoesConfig'

type Props = {
  id: string
  label: string
  required?: boolean
  multiple?: boolean
  files: File[]
  error?: string
  onChange: (files: File[]) => void
}

export function FinanceFormFileInput({
  id,
  label,
  required,
  multiple,
  files,
  error,
  onChange,
}: Props) {
  return (
    <div className='flex flex-col gap-1.5'>
      <label
        htmlFor={id}
        className='font-medium text-[var(--font-color-label)] uppercase tracking-wider'
        style={{ fontSize: 'var(--font-size-label)' }}
      >
        {label}
        {required ? ' *' : ''}
      </label>
      <input
        id={id}
        type='file'
        multiple={multiple}
        accept={FINANCE_FILE_ACCEPT}
        className='w-full rounded-md border border-[var(--glass-border)] bg-[var(--glass-bg)] px-3 py-2.5 text-[13px] text-[var(--text-primary)] file:mr-3 file:rounded-md file:border-0 file:bg-[var(--brand-primary-muted)] file:px-3 file:py-1.5 file:text-[13px] file:font-medium file:text-[var(--brand-primary)] transition-colors focus:border-[var(--brand-primary)] focus:outline-none focus:ring-1 focus:ring-[var(--brand-primary-muted)]'
        onChange={(e) => {
          const picked = Array.from(e.target.files ?? [])
          onChange(multiple ? picked : picked.slice(0, 1))
        }}
      />
      {files.length > 0 && (
        <ul className='space-y-0.5 text-[var(--text-muted)]' style={{ fontSize: 'var(--font-size-xs)' }}>
          {files.map((file) => (
            <li key={`${file.name}-${file.size}`}>
              {file.name} ({(file.size / 1024).toFixed(0)} KB)
            </li>
          ))}
        </ul>
      )}
      <p className='text-[var(--text-muted)]' style={{ fontSize: 'var(--font-size-xs)' }}>
        PDF, imagens ou Office — máx. 10 MB{multiple ? ' · múltiplos arquivos' : ''}
      </p>
      {error && (
        <p className='text-[#e5484d]' style={{ fontSize: 'var(--font-size-xs)' }}>
          {error}
        </p>
      )}
    </div>
  )
}
